import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reducer, { initialState } from "./reducer";
import { StateProvider } from "./StateProvider";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "./AlertTemplate";
const promise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const options = {
  position: positions.TOP_CENTER,
  timeout: 6000,
  offset: "3px",
  transition: transitions.SCALE,
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StateProvider initialState={initialState} reducer={reducer}>
      {/* Stripe Elements provider */}
      <Elements stripe={promise}>
        <AlertProvider template={AlertTemplate} {...options}>
          <App />
        </AlertProvider>
      </Elements>
    </StateProvider>
  </React.StrictMode>
);
